/* The new header search's keyboard support: the arrows walk the visible options, a search suggestion is copied into the field, Enter follows the highlight, and focus goes back on close. */
(function () {
  'use strict';

  if (theme.searchOverlayKeys) return;

  const OPTION_SELECTOR = 'li[role="option"]';
  const HIGHLIGHT_CLASS = 'is-highlighted';
  let optionIds = 0;

  // Arrow keys walk the visible options and Enter follows the highlighted one; Escape stays with the page's close handler.
  function keydown(search, event) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') moveHighlight(search, event);
    else if (event.key === 'Enter') followHighlight(search, event);
  }

  // Options a shopper can actually see: hidden extras and columns the layout hides at this width don't count.
  function visibleOptions(search) {
    return Array.from(search.predictiveSearchResults.querySelectorAll(OPTION_SELECTOR)).filter((li) => li.offsetParent && li.querySelector('a'));
  }

  // An edit leaves the options on screen for the earlier text until the new ones show: the arrows wait for those rather than walk these.
  function markStale(search) {
    resetHighlight(search);
    search.optionsStale = true;
  }

  function markFresh(search) {
    resetHighlight(search);
    search.optionsStale = false;
  }

  function moveHighlight(search, event) {
    const current = search.predictiveSearchResults.classList.contains('is-open') && !search.optionsStale;
    const list = current ? visibleOptions(search) : [];
    if (!list.length) return;
    event.preventDefault();
    const index = list.findIndex((li) => li.classList.contains(HIGHLIGHT_CLASS));
    const next = event.key === 'ArrowDown' ? Math.min(index + 1, list.length - 1) : index - 1;
    list.forEach((li, position) => li.classList.toggle(HIGHLIGHT_CLASS, position === next));
    if (next < 0) return restoreQuery(search);
    const active = list[next];
    if (!active.id) active.id = `predictive-search-option-${++optionIds}`;
    search.input.setAttribute('aria-activedescendant', active.id);
    active.scrollIntoView({ block: 'nearest' });
    copySuggestion(search, active);
  }

  // Baymard: a highlighted search suggestion is copied into the field, so editing starts from it; other options leave the typed query.
  function copySuggestion(search, option) {
    if (search.typedQuery === undefined) search.typedQuery = search.input.value;
    search.input.value = option.closest('.results--queries') ? option.textContent.trim() : search.typedQuery;
  }

  function restoreQuery(search) {
    search.input.removeAttribute('aria-activedescendant');
    if (search.typedQuery !== undefined) search.input.value = search.typedQuery;
    search.typedQuery = undefined;
  }

  function resetHighlight(search) {
    search.predictiveSearchResults.querySelectorAll(`.${HIGHLIGHT_CLASS}`).forEach((li) => li.classList.remove(HIGHLIGHT_CLASS));
    search.input.removeAttribute('aria-activedescendant');
    search.typedQuery = undefined;
  }

  function followHighlight(search, event) {
    const link = search.predictiveSearchResults.querySelector(`.${HIGHLIGHT_CLASS} a`);
    if (!link) return;
    event.preventDefault();
    link.click();
  }

  // Back to the button that opened search, so keyboard users carry on from where they were: a frame later, once every close an Escape
  // sets off has run (on /search the page's own search closes too, blurring what has focus), and only if nothing else has taken it.
  function returnFocus(search) {
    requestAnimationFrame(() => {
      const unfocused = !document.activeElement || document.activeElement === document.body;
      if (unfocused && !search.classList.contains('is-active') && search.trigger.isConnected) search.trigger.focus({ preventScroll: true });
    });
  }

  theme.searchOverlayKeys = { keydown, visibleOptions, resetHighlight, markStale, markFresh, returnFocus };
})();
